import React from "react";
import PropTypes from "prop-types";
import styled from "styled-components";

// context
import { useSiteHeader } from "core/SiteHeader/context/useSiteHeader.js";

// styles
import { bold } from "core/fontStyles";
import colors from "core/colors";
import { convertPxToRem } from "frontend/components/helpers";
import breakpoints from "core/breakpoints";

const MenuTitleStyled = styled.div`
    ${bold}
    color: ${colors.secondary.orca};
    font-size: ${convertPxToRem(15)};

    /* Mobile Specific Styles */
    @media (max-width: ${breakpoints.beforeTablet.rem}) {
        padding: ${convertPxToRem(24)} ${convertPxToRem(16)} ${convertPxToRem(
    12
)};
        background-color: ${colors.primary.diamond};
    }

    @media (min-width: ${breakpoints.tablet.rem}) {
        margin-bottom: ${convertPxToRem(24)};
        color: ${({ $isDarkMode }) =>
            $isDarkMode ? colors.primary.diamond : colors.secondary.orca};
    }
`;

// component
export const MenuTitle = ({ id, title }) => {
    const { isDarkMode } = useSiteHeader();
    return (
        <MenuTitleStyled $isDarkMode={isDarkMode} id={id}>
            {title}
        </MenuTitleStyled>
    );
};

export default MenuTitle;

// prop-types
MenuTitle.propTypes = {
    id: PropTypes.string,
    title: PropTypes.string
};
